<template>
    <!-- 对话框 -->
    <el-dialog title="配置信息" :visible.sync="show" :before-close="closeDialog" width="50%" style="margin: 0 auto;">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <el-form ref="form" :model="submit_data" label-width="100px" style="overflow-y: auto; ">
            
                    <el-form-item label="活动开关:">
                        <el-select v-model="submit_data.status" placeholder="请选择状态"
                            style="width: 150px; margin-right: 20px;">
                            <el-option label="开启" value="1">
                            </el-option>

                            <el-option label="关闭" value="0">
                            </el-option>

                        </el-select>

                    </el-form-item>
                     <span style="color:#c2c4c9;margin-left:10px">注：活动关闭新客扫码下单不会获得奖励</span>
                    <el-form-item label="是否限制新人:" style="margin-top:20px">
                        <el-select v-model="submit_data.is_new_consumer" placeholder="请选择状态"
                            style="width: 150px; margin-right: 20px;">
                            <el-option label="限制" value="1">
                            </el-option>

                            <el-option label="不限制" value="0">
                            </el-option>

                        </el-select>

                    </el-form-item>
                   

                    <el-form-item label="奖励金额:">
                        <el-input v-model="submit_data.amount" placeholder="整数金额" style="width: 150px; margin-right: 5px"> </el-input>+
                        <el-input v-model="submit_data.rate" placeholder="整数百分比" style="width: 150px; margin-right: 5px">
                        </el-input
                        >%
                    </el-form-item>

                   
                        <span style="color:#c2c4c9;margin-left:10px">注：奖励金额=固定金额+订单百分比金额</span>
                  
                
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center;margin-top:100px">
                   
                    <el-button type="primary" @click="onSubmit">确认</el-button>
                    <el-button @click="closeDialog">返回</el-button>
                </div>

            </el-form>



        </div>
    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            isShow: Boolean
        },
        components: {},
        watch: {
            isShow(newData, oldData) {
                _this.show = true;

                _this.getConfig();

            }
        },
        data() {
            return {
                show: false,

               
                // 表单数据
                submit_data: {
                   
                    status: '',
                    is_new_consumer: '',
                    amount: '',
                    rate: ''
                },
             

                submit_rules: {
                    amount: {
                        placeholder: '整数',
                        rules: {
                            required: false,
                            message: '固定金额需为大于等于0的整数',
                            regulation: 'int',
                            rulesData: '0'
                        }

                    },
                    rate: {
                        placeholder: '整数',
                        rules: {
                            required: false,
                            message: '百分比需为大于等于0的整数',
                            regulation: 'int',
                            rulesData: '0'
                        }

                    },
                }
            };
        },
        created() {
            _this = this;
        },
        methods: {
           
 // 关闭方法
            closeDialog() {

                _this.show = false;
                _this.submit_data = {
                    status: '',
                    amount: '',
                    is_new_consumer: '',
                    rate: ''

                };
           

            },
            onSubmit() {


                _this
                    .$post('/Invitedrivercode/editDriverNewConfSub', _this.submit_data,_this.submit_rules)
                    .then((res) => {


                        _this.$message.success(res.msg);
                        _this.closeDialog();

                    })

            },

            getConfig() {
                _this.$post(
                    "/Invitedrivercode/getConfig", {
                    type: 1
                },
                ).then(res => {

                    if (res.data.length != 0) {
                        // 提交过数据
                        _this.submit_data.status = res.data.status;
                        _this.submit_data.rate = res.data.rate;
                        _this.submit_data.amount = res.data.amount;
                        _this.submit_data.is_new_consumer = res.data.is_new_consumer;


                    }



                }).catch((err) => {

                })


            },
          
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
        height: 100%;
    }

    .active_config {
        font-weight: 700;
    }
</style>